import React, { Component } from "react"
import "react-day-picker/lib/style.css"
import moment from "moment"
import ModernDatepicker from "react-modern-datepicker"
import _ from "lodash"
import autosize from "autosize"
import TimePicker from "rc-time-picker"
import "rc-time-picker/assets/index.css"
import { isBoolean } from "util"

export default class Field extends Component {
  state = {}

  componentDidMount() {
    autosize(document.querySelectorAll("textarea"))

    let textArea = document.querySelector("textarea")
    if (textArea) {
      textArea.style.overflow = 'hidden';
      textArea.style.height = '0px';
      textArea.style.height = textArea.scrollHeight + 'px';
    }
  }

  render() {
    const {
      inputName,
      placeholder,
      label,
      inputType,
      options,
      onChange,
      onInput,
      value,
      disabled,
      isFormGroup,
      index,
      i,
      max,
      className,
      checked,
      size,
      style
    } = this.props
    var inputField = undefined
    switch (inputType) {
      case "text":
        inputField = (
          <input
            style={this.props.style}
            type={inputType}
            name={inputName}
            title={value}
            className={`form-control ${className}`}
            value={value}
            disabled={disabled}
            placeholder={placeholder}
            maxLength={max}
            onChange={e => onChange(inputName, e.target.value, index, i)}
          />
        )
        break

      case "password":
        inputField = (
          <input
            type={inputType}
            name={inputName}
            className={`form-control ${className}`}
            value={value}
            disabled={disabled}
            placeholder={placeholder}
            onChange={e => onChange(inputName, e.target.value, index, i)}
          />
        )
        break

      case "number":
        inputField = (
          <input
            style={this.props.style}
            type={inputType}
            name={inputName}
            className={`form-control ${className}`}
            value={value}
            disabled={disabled}
            min={0}
            maxLength={max}
            placeholder={placeholder}
            size={size}
            onChange={e => onChange(inputName, e.target.value, index, i)}
          />
        )
        break

      case "select":
        inputField = (
          <select
            title={this.props.title}
            style={this.props.style}
            onChange={e => onChange(inputName, e.target.value, index, i)}
            onSelect={e => onInput(inputName, e.target.value, index, i)}
            disabled={disabled}
            name={inputName}
            value={value}
            className={`form-control ${className}`}
          >
            <option key="" value="" selected>
              --select--
            </option>
            {options !== undefined &&
              Array.isArray(options) &&
              options.map((data, i) => (
                <option
                  key={i}
                  value={data.value}
                  disabled={isBoolean(data.disabled) ? !data.disabled : false}
                >
                  {data.label}
                </option>
              ))}
          </select>
        )
        break
      case "checkbox":
        let uniqueName = inputName
        inputField = (
          <p
            class={
              className
                ? "manage_permissions emb-chck " + className
                : "manage_permissions emb-chck"
            }
          >
            <input
              type="checkbox"
              class="filled-in"
              id={uniqueName}
              name={uniqueName}
              value={value}
              checked={value}
              disabled={disabled}
              onChange={e => onChange(inputName, e.target.checked, index, i)}
            />
            <label for={uniqueName} class="font-apply-li">
              {label}
            </label>
          </p>
        )
        break
      case "checkboxToggle":
        inputField = (
          <div class={`switch switch-mod  ${className}`}>
            <label>
              <input
                type="checkbox"
                class=""
                name={inputName}
                value={value}
                checked={value}
                disabled={disabled}
                onChange={e => onChange(inputName, e.target.checked, index)}
              />
              <span class="lever" />
            </label>
            {value && <span class="pr-2 font-apply-li">YES</span>}
            {!value && <span class="pl-2 font-apply-li">NO</span>}
          </div>
        )
        break
      case "textarea":
        inputField = (
          <textarea
            type="text"
            className="form-control"
            rows="2"
            cols="50"
            style={style}
            name={inputName}
            disabled={disabled}
            onChange={e => onChange(inputName, e.target.value, index)}
            value={value}
          />
        )
        break
      case "radio":
        uniqueName = inputName
        inputField = (
          <p class="manage_permissions emb-chck">
            <input
              type="radio"
              class="filled-in"
              id={value}
              name={uniqueName}
              value={value}
              checked={checked}
              disabled={disabled}
              onChange={e => onChange(value, e.target.checked, index, i)}
            />
            <label for={value} class="font-apply-li">
              {label}
            </label>
          </p>
        )
        break
      case "date":
        if (this.props.durationETA) {
          let _30DaysForward = new moment().add(this.props.durationETA, "day")
          let valueDate =
            inputName == "processDate"
              ? null
              : value
                ? new Date(value)
                : new Date()
          inputField = !disabled ? (
            <ModernDatepicker
              date={_30DaysForward}
              format={"DD MMM YYYY"}
              onChange={date => onChange(inputName, date, index, i)}
              placeholder={"dd mmm yyyy"}
            />
          ) : (
              <input
                type="text"
                className="form-control"
                name={inputName}
                value={
                  valueDate != "" ? moment(valueDate).format("DD MMM YYYY") : ""
                }
                disabled
              />
            )
          break
        } else {
          let valueDate =
            inputName == "processDate"
              ? null
              : value
                ? new Date(value)
                : new Date()
          inputField = !disabled ? (
            <ModernDatepicker
              date={valueDate}
              format={"DD MMM YYYY"}
              onChange={date => onChange(inputName, date, index, i)}
              placeholder={"dd mmm yyyy"}
            />
          ) : (
              <input
                type="text"
                className="form-control"
                name={inputName}
                value={
                  valueDate != "" ? moment(valueDate).format("DD MMM YYYY") : ""
                }
                disabled
              />
            )
          break
        }

      case "time":
        inputField = (
          <TimePicker
            style={this.props.style}
            value={value != "" && value !== null ? moment(value) : moment(`${new Date().getFullYear(), new Date().getMonth(), new Date().getDay()}`)}
            placeholder={"HH:MM"}
            showSecond={false}
            disabled={disabled}
            format={"HH:mm"}
            onChange={value => onChange(inputName, value, index)}
          />
        )
        break
      default:
        inputField = (
          <input type={inputType} name={inputName} className="form-control" />
        )
    }
    return isFormGroup ? (
      <div class={`form-group ${className}`}>
        <label for="">
          {label && label.endsWith("*") ? label.split("*")[0] : label}
          {label && label.endsWith("*") ? (
            <span className="text-danger madatory-asterisk">
              {label && label.match(/\*/g)}
            </span>
          ) : (
              ""
            )}
        </label>
        {inputField}
      </div>
    ) : (
        inputField
      )
  }
}


// WEBPACK FOOTER //
// ./src/components/Common/Field/Field.js